export const MESSENGER_V2_COMPOSER_ACTIVITY_TYPING = 'typing';
export const MESSENGER_V2_COMPOSER_ACTIVITY_RECORDING_VOICE = 'recording_voice';

const supportedActivities = new Set([
  MESSENGER_V2_COMPOSER_ACTIVITY_TYPING,
  MESSENGER_V2_COMPOSER_ACTIVITY_RECORDING_VOICE,
]);

export const normalizeMessengerV2ComposerActivity = (activity = null) => {
  const normalized = String(activity ?? '')
    .trim()
    .toLowerCase();
  return supportedActivities.has(normalized) ? normalized : null;
};

export const resolveMessengerV2ConversationComposerActivity = (conversation = null) => {
  if (conversation?.typing !== true) return null;
  return (
    normalizeMessengerV2ComposerActivity(
      conversation?.typingActivity ?? conversation?.typing_activity ?? null,
    ) || MESSENGER_V2_COMPOSER_ACTIVITY_TYPING
  );
};
